<template>
    <section class="page">
        <brewery-detail />
        <beer-list />
    </section>
</template>
  
<script>
import BreweryDetail from '@/components/BreweryDetail.vue';
import BeerList from '@/components/BeerList.vue';
export default {
  name: "brewery-view",
  components: {
    BreweryDetail,
    BeerList
  },
};
</script>